import React from "react";
import { Mail, MessageCircle, MapPin, Clock, Phone } from "lucide-react";
import SEO from "@/components/SEO";
import { PageHero } from "@/components/PageHero";
import { Section } from "@/components/Primitives";
import LeadForm from "@/components/LeadForm";
import { useSite } from "@/context/SiteContext";

export default function Contact() {
  const { config, openWhatsApp } = useSite();
  const locations = config?.locations || [];

  return (
    <>
      <SEO title="Contact Us" description="Get in touch with Global Pass Consultants for Labuan setup, Malaysian business services and international expansion. Contact us to know more." path="/contact" />
      <PageHero eyebrow="Get in Touch" title="Request a Confidential Consultation"
        subtitle="Tell us about your business and goals. A member of our advisory team will be in touch. Contact us to know more." />

      <Section className="bg-white">
        <div className="grid lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2 rounded-3xl border border-slate-100 shadow-lg p-6 md:p-8">
            <h2 className="text-2xl font-bold text-navy mb-1">General Inquiry</h2>
            <p className="text-slate-500 mb-6 text-sm">We respond during Malaysian business hours.</p>
            <LeadForm formName="Contact Inquiry" testid="contact-form" />
          </div>

          <aside className="space-y-4">
            <button data-testid="contact-whatsapp" onClick={() => openWhatsApp({ service: "General Inquiry" })} className="w-full rounded-2xl bg-emerald-brand text-white p-5 flex items-center gap-3 text-left hover-lift">
              <MessageCircle className="shrink-0" /><div><div className="font-bold">WhatsApp</div><div className="text-sm text-emerald-50">Chat with our team</div></div>
            </button>
            <div className="rounded-2xl border border-slate-100 p-5 flex items-center gap-3">
              <Mail className="text-navy shrink-0" /><div><div className="font-bold text-navy">Email</div><div className="text-sm text-slate-500">{config?.publicEmail || "Contact us to know more."}</div></div>
            </div>
            <div className="rounded-2xl border border-slate-100 p-5 flex items-center gap-3">
              <Clock className="text-navy shrink-0" /><div><div className="font-bold text-navy">Business Hours</div><div className="text-sm text-slate-500">Monday–Friday, 9:00–18:00 (MYT)</div></div>
            </div>
            <div className="rounded-2xl bg-slate-50 border border-slate-100 p-5">
              <h3 className="font-bold text-navy mb-3">Verified Locations</h3>
              <ul className="space-y-4">
                {locations.map((loc) => (
                  <li key={loc.key} className="flex gap-2">
                    <MapPin size={16} className="text-emerald-brand shrink-0 mt-0.5" />
                    <div className="text-sm">
                      <div className="font-semibold text-navy">{loc.country} <span className="text-slate-400 text-xs">— {loc.label}</span></div>
                      {loc.address && <div className="text-slate-500">{loc.address}</div>}
                      {loc.phone && <div className="text-slate-500 flex items-center gap-1"><Phone size={12} /> {loc.phone}</div>}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </Section>
    </>
  );
}
